"use client";
import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import { contentMarketingAboutData, contentMarketingAndProcessData, contentMarketingFaqs, contentMarketingHeroData } from "src/utils/mock/cotantMarketing";

export default function ContentMarketingComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const videoEditingProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";

    const hasAiTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("content-marketing"));

    return isActive;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: videoEditingProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={contentMarketingHeroData} />
      <TechStats />

      <WhyChooseUs data={contentMarketingAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection techIcons={techIcons} />
          <TechsSection sections={contentMarketingAboutData} mainTitle="About Our Content Marketing" />
        </div>
      </section>

      <FAQSection faqs={contentMarketingFaqs} />
      <CommonContactSection />
    </div>
  );
}
